import { useTriggerRerender } from '../../hooks/use-trigger-rerender'
import { getTimeDiffFromNow } from '../utils'

export function TimeDifference({
  date,
  interval = 1000,
  calculator = getTimeDiffFromNow,
}: {
  date: string
  interval?: number
  calculator?: (date: Date) => string
}) {
  useTriggerRerender(interval)

  return calculator(new Date(date))
}
